import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import styled, { css } from "styled-components";

export const SelectFieldWrapper = styled(ClickOutside)`
  position: relative;
`;

export const SelectFieldChevron = styled(Chevron)`
  position: absolute;
  right: 12px;
  pointer-events: none;
`;

export const SelectedValue = styled.div`
  padding-left: 12px;
  flex: 1;
`;

export const SelectField = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid ${Core.border.muted};
  height: 40px;

  ${({ disabled }) =>
    !disabled
      ? css`
          cursor: pointer;
          &:hover {
            border: 1px solid ${Core.border.hover};

            & > svg {
              color: ${Core.icon.default};
            }
          }
        `
      : css`
          opacity: 0.6;
        `}
`;

export const SearchField = styled.input`
  ${TypographyStyles({})}
  width: 100%;
  height: 100%;
  padding-left: 12px;
  padding-right: 40px;
  border: none;

  &:placeholder {
    color: ${Core.text.subdued};
  }

  &:disabled {
    background-color: ${Core.surface.muted};
  }
`;

export const SelectOptions = styled.div`
  position: absolute;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  top: 40px;
  left: 0;
  border: 1px solid ${Core.border.muted};
  border-top: none;
  z-index: 1;
  background-color: ${Core.surface.inverse};
`;
